import { Component, OnInit } from '@angular/core';
import { UserService } from '@services/user.service';
import { PageService } from '@services/page.service';
import { HttpUtilService } from '@services/http-util.service';
import { environment } from '@env/environment.prod';
import { NotificationsService } from '@services/notifications.service';
import { TranslationService } from '@services/translation.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-verify-phone-and-email',
    templateUrl: './verify-phone-and-email.component.html',
    styleUrls: ['./verify-phone-and-email.component.scss']
})
export class VerifyPhoneAndEmailComponent implements OnInit {
    
    viewMode = 'VERIFY'; // 'VERIFY' | 'EDIT'

    userInfo;
    verificationCode = {
        email : {
            codeSent : false,
            code : null
        },
        phone_number : {
            codeSent : false,
            code : null
        }
    }

    disableSave = false;

    profileData = {
        email : null,
        phone_number : null
    }
    
    updatedData = {
        data : {
            email : null,
            phone_number : null
        }
    }

    phoneNumberObj = {
        label : "Phone Number",
        value : null
    }
    
  constructor(private router:Router,private userService: UserService, private page: PageService, private notifications: NotificationsService, private httpUtils : HttpUtilService,    private translationService:TranslationService) { }
    
    ngOnInit() {
        this.page.updateHideMenu(true);
        this.userInfo = this.userService.getUserInfo();

        this.httpUtils.authGet(environment.apiRoot + '/users/self?role_details=true').subscribe( profile => {
            this.profileData = profile.data;
            this.updatedData.data.email = profile.data.email;
            this.updatedData.data.phone_number = profile.data.phone_number;

            this.phoneNumberObj.value = profile.data.phone_number
        });
    }

    phoneNumberChanged({value}) {
        if(value?.data)this.updatedData.data.phone_number =value
    }

    cancelEdit() {
        this.viewMode = 'VERIFY';
        // Reset values
        this.updatedData.data.email = this.profileData.email;
        this.updatedData.data.phone_number = this.profileData.phone_number;
    }

    saveNewContact() {
        this.disableSave = true;
        this.httpUtils.request("PUT", environment.apiRoot + '/users/self', this.updatedData, null, true).subscribe(data => {
            this.userService.resetUserInfo().subscribe( newInfo => {
                this.userInfo = newInfo;
                this.disableSave = false;
                this.viewMode = 'VERIFY';

                this.profileData.email = this.updatedData.data.email;
                this.profileData.phone_number = this.updatedData.data.phone_number;

            })
        })
    }

    
    requestVerification(contactType) {
        this.userService.getVerificationCode(contactType).subscribe(
            () => {
                this.verificationCode[contactType].codeSent = true;
            },
            (err) => {
                // Unable to send verification at this time
                console.log(err)
                console.log('Unable to send verification at this time')
            }
        )
    }

    sendVerificataion(contactType) {
        
        this.userService.sendVerficationCode(contactType, this.verificationCode[contactType].code).subscribe(
            (data) => {
                var type = contactType == 'email' ? "Email" : "Phone Number";

                this.userInfo[contactType + '_verified'] = true
                this.userService.setUserInfo(this.userInfo)
                this.verificationCode[contactType].codeSent = false;
                this.verificationCode[contactType].code = null;
                this.userService.getCognitoUserAttributes$(true) //refreshes for all other subscribers of CognitoUserAttributes

            },
            (err) => {
                const text = this.translationService.getTranslatedContent('error_attempting_to_validate','Error attempting to Validate')

                console.log(err)
                this.verificationCode[contactType].code = null;
                this.notifications.popNotification(text+": " +err.message, 'X')
            }
        )
    }

    navHome(){
        this.userService.checkForMfaEnabled();
        this.router.navigate(['/home'])
    }
    
}
